module.exports = __webpack_public_path__ + "img/3.b168e8f6.jpg";